if (!Array.prototype.toSorted) {
  Object.defineProperty(Array.prototype, "toSorted", {
    value(this: ArrayLike<any>, compareFn: any) {
      return Array.prototype.slice.call(this).sort(compareFn);
    },
    writable: true,
    configurable: true,
  });
}
